import { render, staticRenderFns } from "./IconDelete.vue?vue&type=template&id=1d0abee9"
import script from "./IconDelete.vue?vue&type=script&lang=js"
export * from "./IconDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d0abee9')) {
      api.createRecord('1d0abee9', component.options)
    } else {
      api.reload('1d0abee9', component.options)
    }
    module.hot.accept("./IconDelete.vue?vue&type=template&id=1d0abee9", function () {
      api.rerender('1d0abee9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/table/IconDelete.vue"
export default component.exports